import { useRef, useState } from 'react'
import { ScrollView } from 'react-native'

import { useRoute } from '@react-navigation/native'
import Header from '@zet/common/components/header'
import { B5, Icon, colors } from '@zet/design-system'
import { Button } from '@zet/design-system/button'
import { Stack, XStack } from '@zet/design-system/layout'
import { KeyBoardWrapper } from '@zet/utils'

import { i18n } from '../../localization'
import { BankDetailsForm } from './BankDetailsForm'
import { PopupAddBankAccount } from './PopupAddBankAcount'

export const AddBankAccount = () => {
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(false)
  const submitRef = useRef(null)
  const [popup, setPopup] = useState(false)
  const [isError, setIsError] = useState(false)
  const [isSubmitLoading, setIsSubmitLoading] = useState(false)
  const { params } = useRoute()

  return (
    <Stack className="flex-1">
      <Header
        showBackIcon
        title={
          params?.fromEdit
            ? i18n.t('addBankAccount.editAccountDetails')
            : i18n.t('addBankAccount.addAccountDetails')
        }
      />
      <KeyBoardWrapper
        BottomSheet={
          <Stack>
            <Button
              intent={'primary'}
              size={'lg'}
              fullWidth={true}
              onPress={submitRef?.current?.callWrapperBank}
              disabled={isSubmitDisabled}
              loading={isSubmitLoading}
              eventName="click_action"
              eventPayload={{
                item_name: 'home_page_add_bank_details',
              }}
            >
              {i18n.t('addBankAccount.addAccount')}
            </Button>
          </Stack>
        }
        wrapperStyle={'py-3 px-3'}
      >
        {popup && (
          <PopupAddBankAccount
            isError={isError}
            popupControl={() => setPopup(false)}
          />
        )}
        <XStack className="bg-warning-10 flex-1 items-center px-2 py-2">
          <Icon type="InfoOutlined" color={colors.warning[150]} />
          <B5 className="ml-2 mr-2 flex-1">
            {i18n.t('addBankAccount.linkPAN')}
          </B5>
        </XStack>
        <ScrollView className="bg-neutral-white100 px-3 pt-[12]">
          <BankDetailsForm
            ref={submitRef}
            onChangeError={() => setIsError(true)}
            showPopup={() => setPopup(true)}
            setIsSubmitDisabled={setIsSubmitDisabled}
            setIsSubmitLoading={setIsSubmitLoading}
          />
        </ScrollView>
      </KeyBoardWrapper>
    </Stack>
  )
}
